import { ChangeEventHandler, FC } from 'react';
import Pagenation from '../../../../components/common/Pagenation';
import styles from './styles.module.css';
import SelectPageSize from '../../../../components/common/SelectPageSize';
import classNames from 'classnames';

type Props = {
  perPage: number;
  page: number;
  total: number;
  onPage: (page: number) => void;
  onChangePerPage: (perPage: number) => void;
  isToastPopUp?: boolean;
};

const Pager: FC<Props> = ({
  perPage,
  page,
  total,
  onPage,
  onChangePerPage,
  isToastPopUp = false,
}) => {
  const onChangePerPageSelectBox: ChangeEventHandler<HTMLSelectElement> = (
    e
  ) => {
    onChangePerPage(Number(e.target.value));
  };
  return (
    <div
      className={classNames(
        styles.pageContainer,
        isToastPopUp && styles.isToastPopUp
      )}
    >
      <SelectPageSize
        value={`${perPage}`}
        onChange={onChangePerPageSelectBox}
      />
      <div>
        <Pagenation
          page={page}
          onPage={onPage}
          perPage={perPage}
          total={total}
        ></Pagenation>
      </div>
    </div>
  );
};

export default Pager;
